import { colors } from 'style/colors';

export function mapChartColor(src: string) {
  return colors[src];
}